/* ============================================================
   assets/bh-cod-popup.js

   The COD sheet for product pages this theme does not build.

   PageFly and GemPages ship their own product templates. Our section
   is not on them, their buy button posts to /cart/add, and this theme
   has no cart — so the customer landed on a 404 with an order half
   made.

   What it does NOT do is read the page builder's own fields. A bundle
   widget on one of these pages posts prvw_selector_1_2_Option0; those
   are undocumented names belonging to somebody else's app, and wiring
   payment to them means orders break silently the day the app renames
   one. So the widget is left to do its job, the items go into the
   cart the way it intends, and this reads /cart.js afterwards —
   Shopify's own state, right for this widget and for the next one.

   Loads only on app-built product pages. Our own pages still ship two
   script files; nothing here is on their critical path.
   ============================================================ */
(function () {
  'use strict';

  var sheet = document.querySelector('[data-bh-sheet]');
  if (!sheet) return;

  var ENDPOINT = sheet.dataset.endpoint || '';
  var SHIPPING = parseInt(sheet.dataset.shipping, 10) || 0;

  var box      = sheet.querySelector('.bh-sheet__box');
  var bodyEl   = sheet.querySelector('.bh-sheet__body');
  var footEl   = sheet.querySelector('.bh-sheet__foot');
  var doneEl   = sheet.querySelector('[data-bh-sheet-done]');
  var basketEl = sheet.querySelector('[data-bh-basket]');
  var formEl   = sheet.querySelector('[data-bh-sheet-form]');
  var submitEl = sheet.querySelector('[data-bh-sheet-submit]');
  var ctaEl    = sheet.querySelector('[data-bh-sheet-cta]');
  var errEl    = sheet.querySelector('[data-bh-sheet-formerr]');
  var resume   = document.querySelector('[data-bh-resume]');
  var resumeWhat = resume && resume.querySelector('[data-bh-resume-what]');

  /* On /cart the sheet is the page, not an overlay over one: it is already
     open, there is nothing behind it to dim, and closing it would leave a
     blank screen. */
  var INLINE = sheet.hasAttribute('data-bh-inline');

  var STORE_KEY = 'bh_cod_draft';
  var cart = null;
  var sending = false;
  var lastFocus = null;
  /* Set the moment the worker says the order exists, and never unset. From
     then on closing the sheet is not abandoning anything, the basket is an
     order rather than a cart, and no second success may draw a second
     confirmation. */
  var ordered = false;
  /* What the button and the breakdown promised, so the failure log and the
     confirmation's fallback quote the same figure the customer saw. */
  var quoted = 0;

  /* Slow-network budget. At CALM_MS the button stays locked and a calm line
     says we are still sending; only a real refusal, a network failure after
     the one retry, or BUDGET_MS in total is called a failure. Unlocking at
     12 s — what the product page form does — invites a second press while
     the first order is still being created. */
  var CALM_MS = 12000;
  var BUDGET_MS = 35000;
  var PENDING_WAIT_MS = 3000;

  var label = function (k, fallback) { return sheet.dataset[k] || fallback; };
  var wait = function (ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); };
  var ERR_SEND = 'Narudžba nije poslana. Provjerite internet i pokušajte ponovo, ili nas nazovite.';

  /* ---------- money ---------------------------------------- */
  /* Same trick as the main form: derive the shop's prefix and suffix from
     one amount Liquid rendered, rather than parsing money_format. */
  var MONEY_PRE = '';
  var MONEY_SUF = '';
  (function () {
    var s = sheet.dataset.moneySample || '';
    var first = s.search(/\d/);
    var last = s.length - 1 - String(s).split('').reverse().join('').search(/\d/);
    if (first >= 0) {
      MONEY_PRE = s.slice(0, first);
      MONEY_SUF = s.slice(last + 1);
    }
  })();

  function money(cents) {
    var n = cents / 100;
    var s = n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ',');
    return MONEY_PRE + s + MONEY_SUF;
  }

  /* ---------- validation ----------------------------------- */
  /* Deliberately the same rules as the main form and the worker. Three
     copies of a rule is two too many, but the worker re-checks everything
     anyway, so the worst a drift here can do is let something through to
     be refused server-side rather than turn a good order away. */
  var RULES = {
    name:    function (v) { return v.trim().length >= 3; },
    /* Same normalisation as bh-cod-form.js and the worker: shed 00, 387 and
       a leading zero, then count. Raw digits accepted 06487019 — one short
       of a real mobile — and let Shopify refuse it after the fact. */
    phone:   function (v) {
      var d = v.replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, '');
      return d.length >= 8 && d.length <= 12;
    },
    address: function (v) { return v.trim().length >= 4; },
    city:    function (v) { return v.trim().length >= 2; },
    zip:     function (v) { return v === '' || /^\d{5}$/.test(v.trim()); },
    email:   function (v) { return v === '' || /^[^\s@]+@[^\s@.]+\.[^\s@]{2,}$/.test(v.trim()); },
  };
  var REQUIRED = ['name', 'phone', 'address', 'city'];

  /* Same soft check as the product page's form (bh-cod-form.js): past nine
     digits is almost always a typo, so the first press asks and a second
     press with the same number sends it as typed. Never a refusal. */
  function phoneTooLong(v) {
    return v.replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, '').length > 9;
  }
  var phoneWarned = null;

  function fieldOf(k) { return sheet.querySelector('[data-bh-field="' + k + '"]'); }
  function inputOf(k) { var f = fieldOf(k); return f && f.querySelector('.bh-input'); }

  function check(k, show) {
    var i = inputOf(k);
    if (!i) return true;
    var ok = RULES[k](i.value);
    if (show && k === 'phone') {
      var pe = sheet.querySelector('#bh-s-err-phone');
      if (pe && sheet.dataset.errPhoneLabel) pe.textContent = sheet.dataset.errPhoneLabel;
    }
    if (show) {
      fieldOf(k).setAttribute('data-invalid', ok ? 'false' : 'true');
      i.setAttribute('aria-invalid', ok ? 'false' : 'true');
    }
    return ok;
  }

  /* The field's own label minus "(opcionalno)", so the summary names fields
     the way the sheet does. Same as the product page form. */
  function labelOf(k) {
    var f = fieldOf(k);
    var l = f && f.querySelector('label');
    if (!l) return k;
    var opt = l.querySelector('.bh-field__opt');
    var text = l.textContent;
    if (opt) text = text.replace(opt.textContent, '');
    return text.replace(/\s+/g, ' ').trim();
  }

  /* One line above the button, in the footer that never scrolls. `kind`
     remembers what it is saying, so typing can refresh a list of bad fields
     without wiping a send error, and so the calm "still sending" line gets
     the neutral style rather than the red one. */
  var errKind = '';
  function say(kind, text) {
    if (!errEl) return;
    errKind = text ? kind : '';
    errEl.textContent = text || '';
    errEl.hidden = !text;
    if (kind === 'wait' && text) errEl.setAttribute('data-wait', 'true');
    else errEl.removeAttribute('data-wait');
    if (kind === 'ok' && text) errEl.setAttribute('data-ok', 'true');
    else errEl.removeAttribute('data-ok');
    /* a status is read when there is a pause; an error at once */
    errEl.setAttribute('role', kind === 'wait' || kind === 'ok' ? 'status' : 'alert');
  }

  function sayBadFields(bad) {
    if (!bad.length) return say('', '');
    say('form', label('errFormLabel', 'Narudžba nije poslana. Provjerite:') + ' ' + bad.map(labelOf).join(', '));
  }

  /* Bring a field into view inside the sheet. The old offsetTop arithmetic
     measured from the field, not the scrolling body (.bh-field is
     position:relative), so it always scrolled to the top. On /cart the body
     does not scroll at all and the page does. */
  function reveal(el) {
    if (!el) return;
    if (INLINE) {
      var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo(0, y < 0 ? 0 : y);
    } else if (bodyEl) {
      bodyEl.scrollTop += el.getBoundingClientRect().top - bodyEl.getBoundingClientRect().top - 80;
    }
  }

  function validateAll(show) {
    var bad = [];
    Object.keys(RULES).forEach(function (k) {
      if (!check(k, show)) bad.push(k);
    });
    return bad;
  }

  /* ---------- the cart ------------------------------------- */
  function lineLabel(item) {
    var t = item.product_title || item.title || '';
    var v = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return { qty: item.quantity, what: t, variant: v };
  }

  /* ---------- prices: catalogue, never discounted ----------
     The worker creates a DRAFT order from variant ids, and Shopify prices a
     draft at the catalogue price: automatic discounts and discount apps
     (the Pumper volume-discount widget on these pages, for one) never touch
     it. /cart.js, on the other hand, reports those discounts in
     total_price and final_line_price. Quoting them put a figure on the
     button the courier would not honour — on cash on delivery that is an
     argument at the door. So every amount in this sheet comes from the
     original_* fields, which is what the order will actually be. */
  function lineCents(it) {
    if (it.original_line_price != null) return it.original_line_price;
    var unit = it.original_price != null ? it.original_price : it.price;
    return (unit || 0) * (it.quantity || 0);
  }

  function goodsCents() {
    if (!cart) return 0;
    if (cart.original_total_price != null) return cart.original_total_price;
    return (cart.items || []).reduce(function (s, it) { return s + lineCents(it); }, 0);
  }

  function payableCents() { return goodsCents() + SHIPPING; }

  function paintCart() {
    if (!cart || !cart.items || !cart.items.length) return false;

    basketEl.innerHTML = '';
    var pieces = 0;
    cart.items.forEach(function (it) {
      var l = lineLabel(it);
      pieces += l.qty;
      var li = document.createElement('li');
      li.className = 'bh-basket__row';

      var what = document.createElement('span');
      what.className = 'bh-basket__what';
      what.appendChild(document.createTextNode(l.qty + '× ' + l.what + ' '));
      if (l.variant) {
        var small = document.createElement('small');
        small.textContent = '— ' + l.variant;
        what.appendChild(small);
      }

      var price = document.createElement('span');
      price.textContent = money(lineCents(it));

      li.appendChild(what);
      li.appendChild(price);
      basketEl.appendChild(li);
    });

    var goods = goodsCents();
    var payable = goods + SHIPPING;
    quoted = payable;
    var set = function (k, text) {
      var n = sheet.querySelector('[data-bh-sheet-sum="' + k + '"]');
      if (n) n.textContent = text;
    };
    set('product', money(goods));
    set('total', money(payable));
    if (ctaEl && !sending) ctaEl.textContent = ctaEl.dataset.base + ' — ' + money(payable);

    if (resumeWhat) {
      resumeWhat.textContent = pieces + '× · ' + money(payable);
    }
    return true;
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  /* ---------- open and close ------------------------------- */
  function open() {
    if (INLINE) return;
    lastFocus = document.activeElement;
    sheet.hidden = false;
    /* The closed state has to be painted before the open one, or there is no
       transition to watch. A forced reflow does that synchronously.

       This used to wait for requestAnimationFrame, and on the live page the
       callback never ran: the sheet was un-hidden, the page scroll was
       locked, and the box sat at translateY(747) — open in every respect
       except the one the customer could see. A frame that may or may not
       arrive is a poor thing to hang a buy button on. */
    void sheet.offsetHeight;
    sheet.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    if (resume) resume.hidden = true;
    var first = inputOf('name');
    if (first && !ordered) setTimeout(function () { first.focus(); }, 260);
  }

  function close() {
    if (INLINE) return;
    sheet.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    /* wait out the transition before pulling it from the accessibility tree */
    setTimeout(function () { sheet.hidden = true; }, 240);
    /* the basket is still in the cart, so the way back stays on screen */
    if (resume && !ordered && cart && cart.items && cart.items.length) {
      resume.hidden = false;
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Every way out — the ✕, the scrim, Escape, the swipe — comes through
     here. While an offer is up the order already exists, so "close" can
     only mean "no thanks": it declines this offer and moves to the next one
     or the confirmation. Closing outright left the customer on the product
     page with no confirmation and every reason to order again. */
  var declineOffer = null;
  function requestClose() {
    if (INLINE) return;   /* the page itself; there is nothing to close */
    if (declineOffer) { if (!offerBusy) declineOffer(); return; }
    close();
  }

  sheet.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-bh-sheet-close]')) {
      ev.preventDefault();
      requestClose();
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !sheet.hidden) requestClose();
  });
  if (resume) {
    resume.addEventListener('click', function () {
      loadCart()
        .then(function () { if (paintCart()) open(); })
        /* the cart could not be read; /cart is a real page with the same form */
        .catch(function () { location.href = '/cart'; });
    });
  }

  /* ---------- swipe it away -------------------------------- */
  /* Only from the head. Starting the drag anywhere in the body would fight
     the form's own scrolling, and a sheet that closes when you meant to
     scroll to the phone field is worse than one that does not drag. */
  (function () {
    var head = sheet.querySelector('.bh-sheet__head');
    if (!head) return;
    var y0 = 0, dy = 0, dragging = false;

    head.addEventListener('touchstart', function (ev) {
      dragging = true;
      y0 = ev.touches[0].clientY;
      dy = 0;
      box.style.transition = 'none';
    }, { passive: true });

    head.addEventListener('touchmove', function (ev) {
      if (!dragging) return;
      dy = Math.max(0, ev.touches[0].clientY - y0);
      box.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });

    head.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      box.style.transition = '';
      box.style.transform = '';
      /* a third of the sheet, or it closes on every stray thumb */
      if (dy > box.getBoundingClientRect().height / 3) requestClose();
    });
  })();

  /* ---------- draft ---------------------------------------- */
  /* Shared with the main form on purpose: someone who typed their details
     on a normal product page should not type them again here. */
  (function () {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
    if (saved) {
      Object.keys(RULES).forEach(function (k) {
        var i = inputOf(k);
        if (i && saved[k]) i.value = saved[k];
      });
    }
    formEl.addEventListener('input', function () {
      var d = {};
      Object.keys(RULES).forEach(function (k) {
        var i = inputOf(k);
        if (i) d[k] = i.value;
      });
      try { localStorage.setItem(STORE_KEY, JSON.stringify(d)); } catch (e) {}
    });
  })();

  Object.keys(RULES).forEach(function (k) {
    var i = inputOf(k);
    if (!i) return;
    i.addEventListener('blur', function () {
      /* the too-long warning stays until the number is edited — clearing it
         on blur moves the button under a second tap on ORDER */
      if (k === 'phone' && phoneWarned !== null && i.value.trim() === phoneWarned) return;
      check(k, true);
    });
    i.addEventListener('input', function () {
      if (fieldOf(k).getAttribute('data-invalid') === 'true') check(k, true);
      /* the list of bad fields shrinks as they are fixed and goes when none
         are left; a send error is left alone */
      if (errKind === 'form') sayBadFields(validateAll(true));
    });
  });

  /* On the cart page there is no button to wait for: the customer is
     already here, with items, and the form is the reason the page exists. */
  if (INLINE) {
    loadCart()
      .then(function (c) {
        paintCart();
        /* "Promijeni izbor" closes the sheet on a product page; here there is
           nothing to close, so it points back at the product instead of
           doing nothing at all. */
        var edit = sheet.querySelector('[data-bh-sheet-back]');
        if (edit && c.items && c.items[0] && c.items[0].url) {
          edit.setAttribute('href', c.items[0].url);
          edit.removeAttribute('data-bh-sheet-close');
        }
      })
      /* Without the cart the button cannot send anything. It used to stay
         live and do nothing when pressed; say so instead. */
      .catch(function () { say('send', label('errSendLabel', ERR_SEND)); });
  }

  /* ---------- take over the navigation, not the widget ------
     The widget is left completely alone: its click handler runs, its bundle
     logic runs, its items go into the cart the way its app intends. The one
     thing taken from it is where the browser goes next, because where it
     went was /cart, and this theme has no cart.

     Two ways in, because a form can be sent two ways and the widget on this
     shop uses the one that is invisible:

       requestSubmit() and a real click fire a `submit` event, which can be
       cancelled. That is the path the harness exercised.

       form.submit() fires NOTHING. It navigates. No listener anywhere sees
       it, which is exactly why the first version of this looked right in
       every test and did nothing at all on the live page.

     So the method itself is replaced for cart forms. The original is kept
     and is still the escape hatch: if the cart cannot be read, the customer
     goes wherever they were going rather than nowhere. */
  /* ── the reliable trigger: the cart itself ─────────────────
     Watching the button was a mistake twice over. A form can be sent three
     ways — requestSubmit, a submit event, form.submit() — and a widget can
     skip all of them by fetching /cart/add itself and then assigning
     window.location, which nothing can intercept.

     What no widget can avoid is the request. Whoever adds to the cart, by
     whatever route, talks to /cart/add. So that is what is watched: when
     such a request succeeds, the cart is read and the sheet opens. No field
     names, no button, no form.

     It works whether the widget navigates afterwards or not — and if its
     own setting is switched to stay on the page, this is the whole
     mechanism and nothing else is needed. */
  function onCartAdd() {
    if (!ENDPOINT || INLINE) return;
    /* With the button set to "Keep shopping" nothing else happens after a
       successful add — no navigation, no feedback. If this cannot open the
       sheet, the customer has clicked and watched nothing happen, with their
       items sitting in a cart they were never sent to. So a failure here
       goes to /cart, which is a real page with the same form on it. */
    var strand = function () { location.href = '/cart'; };
    loadCart()
      .then(function () { if (paintCart()) open(); else strand(); })
      .catch(strand);
  }

  (function () {
    var isAdd = function (u) { return String(u).indexOf('/cart/add') !== -1; };

    var realFetch = window.fetch;
    if (realFetch) {
      window.fetch = function (url, opts) {
        var out = realFetch.apply(this, arguments);
        var target = url && url.url ? url.url : url;
        if (isAdd(target)) out.then(function (r) { if (r && r.ok) onCartAdd(); }).catch(function () {});
        return out;
      };
    }

    var realOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isAdd(url)) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) onCartAdd();
        });
      }
      return realOpen.apply(this, arguments);
    };
  })();

  var nativeSubmit = HTMLFormElement.prototype.submit;

  function isCartForm(form) {
    return !!form && (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }

  /* The widget may have added its lines by fetch already, or be relying on
     this navigation to do it. Posting the form again is harmless — Shopify
     merges identical lines — and it is the only way to be sure. */
  function takeOver(form) {
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) btn.disabled = true;
    var give = function () {
      if (btn) btn.disabled = false;
      nativeSubmit.call(form);
    };

    /* A second press of the same buy button must not be a second item.
       Opening the sheet puts the product in the cart; closing it leaves it
       there, so pressing "Naruči" again used to add another one — a
       customer who looked, closed and came back was quoted two, and a
       landing with three order buttons made it easy. When the variant is
       already in the cart its quantity is set to what the form asks for
       instead; anything else (a widget's basket of several lines) is
       added exactly as before. */
    var data = new FormData(form);
    var id = String(data.get('id') || '');
    var qty = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
    var addIt = function () {
      return fetch(form.getAttribute('action'), {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/javascript' },
      });
    };

    return loadCart()
      .catch(function () { return null; })
      .then(function (c) {
        var line = id && c && c.items && c.items.filter(function (i) { return String(i.variant_id) === id; })[0];
        if (!line) return addIt();
        if (line.quantity === qty) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: qty }),
        });
      })
      .then(function () { return loadCart(); })
      .then(function () {
        if (btn) btn.disabled = false;
        if (paintCart()) open();
        else give();
      })
      .catch(give);
  }

  if (ENDPOINT) {
    HTMLFormElement.prototype.submit = function () {
      if (!isCartForm(this)) return nativeSubmit.apply(this, arguments);
      takeOver(this);
    };

    document.addEventListener('submit', function (ev) {
      if (!isCartForm(ev.target)) return;
      ev.preventDefault();
      takeOver(ev.target);
    }, true);
  }

  /* The same reporting the product page does: whoever was refused here
     typed an address and asked to buy, and without this they vanish. Fire
     and forget, keepalive so a closed tab still delivers it, and wrapped so
     failing to log a failure never becomes a second one. */
  function reportFailure(err, payload) {
    if (!ENDPOINT) return;
    try {
      fetch(ENDPOINT.replace(/\/+$/, '') + '/fail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          reason: err && (err.status === 429 || err.code === 'rate') ? 'rate'
                : err && err.status ? 'http-' + err.status
                : err ? 'mreza' : 'timeout',
          /* What the worker said, not just which form asked. Three refusals
             were logged as "popup" and the actual reason — an invalid email,
             a short phone — had to be dug out by hand afterwards, while the
             customer waited. */
          detail: 'popup: ' + (err ? String(err.detail || err.code || err.message || '').slice(0, 280) : 'nema odgovora za ' + (BUDGET_MS / 1000) + ' s'),
          name: payload.name, phone: payload.phone, address: payload.address,
          city: payload.city, zip: payload.zip, email: payload.email,
          product: (cart && cart.items || []).map(function (i) { return i.title; }).join(' + '),
          total: quoted,
          url: location.href
        })
      }).catch(function () {});
    } catch (e) { /* never let logging break the sheet */ }
  }

  /* ---------- submit --------------------------------------- */
  function lockButton(on) {
    submitEl.disabled = on;
    submitEl.style.opacity = on ? '.65' : '';
    if (ctaEl) {
      ctaEl.textContent = on
        ? label('sendingLabel', 'ŠALJEMO…')
        : ctaEl.dataset.base + ' — ' + money(quoted || payableCents());
    }
  }

  /* A send that did not go through, said plainly and where they tapped.
     The worker names its reasons ('phone', 'rate', 'validation'); this
     reads the name, so a mistyped number is not answered with "check your
     internet" — advice that cannot work, about a problem the customer
     could fix in seconds. */
  function failSoft(err, payload) {
    sending = false;
    lockButton(false);
    reportFailure(err, payload);
    var code = err && err.code;
    var rate = err && (err.status === 429 || code === 'rate');
    if (code === 'phone') {
      var msg = label('errPhoneLabel', 'Provjerite broj telefona — izgleda da nedostaje cifra.');
      say('send', msg);
      var pe = sheet.querySelector('#bh-s-err-phone');
      if (pe) pe.textContent = msg;
      fieldOf('phone').setAttribute('data-invalid', 'true');
      var pin = inputOf('phone');
      if (pin) { pin.setAttribute('aria-invalid', 'true'); reveal(pin); pin.focus(); }
      return;
    }
    say('send', rate
      ? label('errRateLabel', 'Već ste poslali narudžbu maloprije. Sačekajte malo ili nas nazovite.')
      : label('errSendLabel', ERR_SEND));
  }

  /* Bound to the button AND to the form. The button is how almost everyone
     orders, but on a phone the keyboard's own Go key fires a form submit
     and nothing else, and until now that did exactly nothing — the customer
     pressed the key the keyboard offered them and the sheet sat there. The
     form's action is not a cart form, so the takeover above ignores it. */
  function placeOrder() {
    if (sending || ordered) return;
    var bad = validateAll(true);
    if (bad.length) {
      sayBadFields(bad);
      var el = inputOf(bad[0]);
      reveal(el);
      el.focus();
      return;
    }
    var pIn = inputOf('phone');
    var pVal = pIn ? pIn.value.trim() : '';
    if (pIn && phoneTooLong(pVal) && phoneWarned !== pVal) {
      phoneWarned = pVal;
      var pe = sheet.querySelector('#bh-s-err-phone');
      if (pe && sheet.dataset.warnPhoneLabel) pe.textContent = sheet.dataset.warnPhoneLabel;
      fieldOf('phone').setAttribute('data-invalid', 'true');
      say('warn', sheet.dataset.warnPhoneFormLabel || '');
      reveal(pIn);
      pIn.focus();
      return;
    }
    say('', '');

    /* The cart could not be read when the sheet opened (or was emptied
       since). Try once more now rather than leave a button that does
       nothing; if it still cannot be read, say the order was not sent. */
    if (!cart || !cart.items || !cart.items.length) {
      sending = true;
      lockButton(true);
      loadCart()
        .then(function () {
          sending = false;
          if (!paintCart()) throw new Error('prazna korpa');
          lockButton(false);
          placeOrder();
        })
        .catch(function () {
          sending = false;
          lockButton(false);
          say('send', label('errSendLabel', ERR_SEND));
        });
      return;
    }

    sending = true;
    lockButton(true);

    var val = function (k) { var i = inputOf(k); return i ? i.value.trim() : ''; };
    var payload = {
      lineItems: cart.items.map(function (i) {
        return { variantId: String(i.variant_id), quantity: i.quantity };
      }),
      name: val('name'),
      phone: val('phone'),
      address: val('address'),
      city: val('city'),
      zip: val('zip'),
      email: val('email'),
      note: 'COD — popup na stranici iz aplikacije',
      url: location.href,
    };
    /* the identical bytes every time: a resend after 409 must be the same
       order to the worker's fingerprint, not a lookalike */
    var body = JSON.stringify(payload);
    var started = Date.now();
    var failed = false;
    var netLeft = 1;

    var declare = function (err) {
      if (failed || ordered) return;
      failed = true;
      clearTimeout(calm);
      clearTimeout(cap);
      failSoft(err, payload);
    };
    /* Still waiting is not failing. The button stays locked — unlocking it
       here is how one customer becomes two orders — and the line says so. */
    var calm = setTimeout(function () {
      if (!failed && !ordered) say('wait', label('stillSendingLabel', 'Još šaljemo narudžbu — ne zatvarajte stranicu.'));
    }, CALM_MS);
    var cap = setTimeout(function () { declare(null); }, BUDGET_MS);

    /* keepalive, because the tab can go away while this is in flight; one
       quiet retry, and only when the request never reached the worker (a
       rejected fetch is a dropped connection — a lift, a tunnel). Anything
       the worker answered is a decision and is not repeated, with one
       exception below. */
    var post = function () {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: body,
      }).catch(function (err) {
        if (netLeft <= 0) throw err;
        netLeft -= 1;
        return wait(1200).then(post);
      });
    };

    var round = function () {
      return post().then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (r.ok) return d;
          /* 409 pending: the worker is creating this very order already —
             usually the first attempt, still in Shopify's hands. Keep waiting
             and ask again with the same payload; the answer will be the
             order (deduped) once it exists. Within the overall budget only. */
          if (r.status === 409 && d && d.error === 'pending' && !failed &&
              Date.now() - started + PENDING_WAIT_MS < BUDGET_MS) {
            return wait(PENDING_WAIT_MS).then(round);
          }
          var e = new Error('HTTP ' + r.status);
          e.status = r.status;
          e.code = d && d.error;
          e.detail = d && d.detail;
          throw e;
        });
      });
    };

    round()
      .then(function (data) {
        clearTimeout(calm);
        clearTimeout(cap);
        /* Even after the budget ran out and a failure was declared: the
           order exists, and being told so is the one thing the customer is
           owed. */
        orderPlaced(data || {}, payload);
      })
      .catch(declare);
  }

  submitEl.addEventListener('click', placeOrder);
  if (formEl) {
    formEl.addEventListener('submit', function (ev) {
      ev.preventDefault();
      placeOrder();
    });
  }


  /* ---------- the order exists ------------------------------ */
  /* Past this line the order is in Shopify. Everything that follows is a
     bonus, and no bonus may cost the customer being told it was taken —
     so the things that say "done" happen here, first, not at the end of
     the offer queue: the heading, the cart, the resume bar. */
  function orderPlaced(data, payload) {
    if (ordered) return;
    ordered = true;
    sending = false;
    say('', '');
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}

    var h = sheet.querySelector('#bh-sheet-h');
    if (h && sheet.dataset.confirmedHLabel) h.textContent = sheet.dataset.confirmedHLabel;

    /* the cart has become an order; leaving it filled offers the same basket
       again on the next page, and the resume bar would invite a second order */
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
    if (resume) resume.hidden = true;
    /* on the cart page the heading and the basket above the sheet belong to
       an order that no longer needs placing */
    if (INLINE) document.body.setAttribute('data-bh-ordered', '');
    /* closed while it was sending: bring it back for the answer */
    if (!INLINE && !sheet.hasAttribute('data-open')) open();

    try {
      startOffers(data, payload);
    } catch (e) {
      try { showDone(data, payload); } catch (e2) { lastResort(data); }
    }
  }

  /* The confirmation itself could not be drawn. Say the one true thing that
     is left, in the place the customer is already looking. */
  function lastResort(data) {
    var num = (data && (data.orderNumber || data.name)) || '';
    offers.forEach(function (o) { o.hidden = true; });
    if (footEl) footEl.hidden = false;
    say('ok', label('confirmedFallback', 'Narudžba je primljena. Broj narudžbe: ') + num);
    submitEl.disabled = true;
    submitEl.hidden = true;
  }


  /* ---------- one-click upsell queue ----------------------- */
  /* Same offers, same rules as the form on our own product page: they run
     only AFTER the worker has created the order, each one appends a line to
     an order that already exists, and abandoning at any point leaves
     precisely the order the customer would have had. The cards come from
     sections/bh-offers.liquid, which is why both forms can show them.

     The worker has to return orderId and a short-lived token for any of
     this to run. Without them the customer goes straight to the
     confirmation, exactly as before. */
  var offers = [].slice.call(document.querySelectorAll('[data-bh-pane="offer"]'));
  var offerIdx = 0;
  var runTotal = 0;
  var orderRef = null;
  var offerBusy = false;
  var accepted = [];
  var TIMER_MIN = parseInt(sheet.dataset.offerTimer, 10) || 0;
  var tick = null;
  var receivedEl = sheet.querySelector('[data-bh-sheet-received]');
  var closeBtn = sheet.querySelector('.bh-sheet__x');
  var closeLabel = closeBtn ? closeBtn.getAttribute('aria-label') : '';

  function stopTimer() { if (tick) { clearInterval(tick); tick = null; } }

  function startTimer(el, onExpiry) {
    stopTimer();
    var out = el.querySelector('[data-bh-offer-timer]');
    if (!out || TIMER_MIN <= 0) { if (out) out.hidden = true; return; }
    var left = TIMER_MIN * 60;
    out.hidden = false;
    var paint = function () {
      var m = Math.floor(left / 60), s = left % 60;
      out.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    };
    paint();
    tick = setInterval(function () {
      left -= 1;
      if (left <= 0) { stopTimer(); out.textContent = '0:00'; return onExpiry(); }
      paint();
    }, 1000);
  }

  function startOffers(data, payload) {
    runTotal = data.totalCents != null ? data.totalCents : quoted;
    orderRef = (data.orderId && data.token) ? { id: data.orderId, token: data.token } : null;
    /* a refused phone skips the offers: the field to fix it is on the
       confirmation, and every minute before it is a minute to lose them */
    if (!orderRef || !offers.length || data.phoneUnverified) return showDone(data, payload);
    /* the offer takes the sheet over: the basket, the form and the button
       all describe a decision already made */
    bodyEl.hidden = true;
    footEl.hidden = true;
    /* …but first, in so many words, that the order went through */
    if (receivedEl) {
      receivedEl.textContent = label('orderReceivedLabel', '✓ Narudžba {number} je primljena')
        .replace('{number}', data.orderNumber || data.name || '');
      receivedEl.hidden = false;
    }
    offerIdx = 0;
    nextOffer(data, payload);
  }

  function nextOffer(data, payload) {
    try {
      drawOffer(data, payload);
    } catch (e) {
      /* a broken offer must not swallow a good order */
      try { showDone(data, payload); } catch (e2) { lastResort(data); }
    }
  }

  function drawOffer(data, payload) {
    stopTimer();
    declineOffer = null;
    offers.forEach(function (o) { o.hidden = true; });
    if (offerIdx >= offers.length) return showDone(data, payload);

    var el = offers[offerIdx];
    /* the cards are rendered outside the sheet, so they are moved into it
       for the moment they are on screen */
    box.insertBefore(el, doneEl);
    el.hidden = false;

    var yes = el.querySelector('[data-bh-offer-yes]');
    var no = el.querySelector('[data-bh-offer-no]');
    var skip = function () {
      if (declineOffer !== skip) return;   /* this offer already moved on */
      offerIdx++;
      nextOffer(data, payload);
    };
    declineOffer = skip;
    /* the ✕ is "no thanks" now, and says so to a screen reader */
    if (closeBtn && no) closeBtn.setAttribute('aria-label', no.textContent.trim() || closeLabel);
    if (no) no.onclick = skip;
    if (yes) yes.onclick = function () { acceptOffer(el, data, payload); };
    startTimer(el, skip);
  }

  function acceptOffer(el, data, payload) {
    if (offerBusy) return;
    offerBusy = true;
    stopTimer();
    var yes = el.querySelector('[data-bh-offer-yes]');
    if (yes) { yes.disabled = true; yes.style.opacity = '.65'; }
    var title = el.querySelector('.bh-offer__h');
    var name = title ? title.textContent.trim() : '';
    if (name) accepted.push(name);
    var price = parseInt(el.dataset.price, 10) || 0;

    /* Whatever happens next, move on exactly once — a late answer after the
       nine-second give-up must not advance the queue a second time. */
    var settled = false;
    var done = function (added) {
      if (settled) return;
      settled = true;
      offerBusy = false;
      if (yes) { yes.disabled = false; yes.style.opacity = ''; }
      if (added != null) runTotal = added;
      offerIdx++;
      nextOffer(data, payload);
    };
    /* Failed or unanswered: the line is very probably not on the order, so
       it comes back out of the recap and is not added to the total. This is
       cash on delivery — a receipt promising an item the driver is not
       carrying is worse than one that never mentioned it. Same as the
       product page form; the shop's confirmation call sorts out a late
       arrival. */
    var drop = function () {
      if (settled) return;
      if (name) {
        var i = accepted.lastIndexOf(name);
        if (i > -1) accepted.splice(i, 1);
      }
      done(null);
    };
    var give = setTimeout(drop, 9000);

    fetch(ENDPOINT.replace(/\/+$/, '') + '/upsell', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderId: orderRef.id, token: orderRef.token,
        variantId: el.dataset.variant,
        discountPct: parseInt(el.dataset.discount, 10) || 0,
        quantity: 1,
      }),
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (res) {
        clearTimeout(give);
        done(res && res.totalCents != null ? res.totalCents : runTotal + price);
      })
      .catch(function () { clearTimeout(give); drop(); });
  }

  function showDone(data, payload) {
    declineOffer = null;
    if (closeBtn) closeBtn.setAttribute('aria-label', closeLabel);
    var set = function (sel, text) {
      var n = sheet.querySelector(sel);
      if (n) n.textContent = text;
    };
    var paid = runTotal || (data.totalCents != null ? data.totalCents : quoted);
    set('[data-bh-sheet-order]', data.orderNumber || data.name || '#—');
    set('[data-bh-sheet-paid]', money(paid));
    set('[data-bh-sheet-phone]', payload.phone);
    if (data.phoneUnverified && orderRef) showBadPhone(payload);

    stopTimer();
    offers.forEach(function (o) { o.hidden = true; });
    /* the confirmation says it in full below; the one-liner was for the offers */
    if (receivedEl) receivedEl.hidden = true;
    bodyEl.hidden = true;
    footEl.hidden = true;
    doneEl.hidden = false;
    var order = sheet.querySelector('[data-bh-sheet-order]');
    if (order && accepted.length) {
      accepted.forEach(function (name) {
        var li = document.createElement('span');
        li.className = 'bh-recap__add';
        li.textContent = '+ ' + name;
        order.parentElement.appendChild(li);
      });
    }

    /* Not for a deduped answer: that order was counted when it was made,
       and this is the customer being shown it again. */
    if (window.dataLayer && !data.deduped) {
      window.dataLayer.push({
        event: 'purchase',
        transaction_id: data.orderNumber,
        /* the total after any accepted offer */
        value: paid / 100,
        currency: sheet.dataset.currency || 'BAM'
      });
    }
  }

  /* Shopify would not take the number and the order was saved without one.
     On cash on delivery the courier's first act is a call, so say so in
     place of "we noted your number" and give the customer one field to fix
     it — guarded by the same signed order token the offers use. */
  function showBadPhone(payload) {
    var box = sheet.querySelector('[data-bh-sheet-badphone]');
    if (!box) return;
    var sub = sheet.querySelector('[data-bh-sheet-sub]');
    if (sub && sheet.dataset.confirmedBadphoneLabel) sub.textContent = sheet.dataset.confirmedBadphoneLabel;
    var inp = box.querySelector('[data-bh-sheet-badphone-input]');
    var btn = box.querySelector('[data-bh-sheet-badphone-save]');
    var msg = box.querySelector('[data-bh-sheet-badphone-msg]');
    if (inp) inp.value = payload.phone || '';
    box.hidden = false;
    if (!btn) return;
    btn.addEventListener('click', function () {
      var v = inp ? inp.value : '';
      var d = v.replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, '');
      if (!(d.length >= 8 && d.length <= 12)) {
        if (msg) msg.textContent = sheet.dataset.errPhoneLabel || '';
        if (inp) inp.focus();
        return;
      }
      var was = btn.textContent;
      btn.disabled = true;
      btn.textContent = sheet.dataset.sendingLabel || '…';
      if (msg) msg.textContent = '';
      fetch(ENDPOINT.replace(/\/+$/, '') + '/phone', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({ orderId: orderRef.id, token: orderRef.token, phone: v })
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function () {
          if (inp) inp.disabled = true;
          btn.textContent = sheet.dataset.savedLabel || '✓';
          if (msg) msg.textContent = sheet.dataset.badphoneOkLabel || '';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = was;
          /* never a tick over a number that still cannot be rung */
          if (msg) msg.textContent = sheet.dataset.badphoneFailLabel || '';
        });
    });
  }
})();
